/**
 * Feriados e suspensões da conta (docs/PLANO_TELAS_TAGS_FERIADOS.md, Bloco 2): a lista e o
 * interruptor do Bloco E de PLANO_CONTAGEM_PRAZOS e o lançamento fora de um prazo, pelos
 * lugares do acervo. Chega-se por Configurações e pelo Calendário; sem item no menu.
 */
import { CalendarOff, Plus } from 'lucide-react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Fab } from '@/components/ui/Fab';
import { PageHeader } from '@/components/ui/PageHeader';
import { useAtuacao } from '@/lib/delegacao/atuacao';

import { LancarAvulsoDialog } from './LancarAvulsoDialog';
import { ListaDeFeriados } from './ListaDeFeriados';
import type { FeriadosPageState } from './rota';

const CONFIGURACOES = '/app/configuracoes';
/** O "voltar" diz para onde volta: as duas portas de entrada da página. */
const ROTULO_DA_ORIGEM: Record<string, string> = { [CONFIGURACOES]: 'Configurações', '/app/calendario': 'Calendário' };

function FeriadosPage() {
  const location = useLocation();
  const voltarPara = (location.state as FeriadosPageState | null)?.voltarPara ?? CONFIGURACOES;
  const atuacao = useAtuacao();
  const podeAlterar = !atuacao || atuacao.nivel === 'COLABORACAO';
  const [lancando, setLancando] = useState(false);

  // Na delegação, a lista é da conta do titular.
  const titulo = atuacao ? `Feriados e suspensões da conta de ${atuacao.titularNome}` : 'Feriados e suspensões';
  const subtitulo =
    (atuacao
      ? 'Os dias lançados porque a conta do prazo não os pegou. Valem só nas contas desta conta.'
      : 'Os dias que você lançou porque a conta do prazo não os pegou. Valem só nas suas contas.') +
    (podeAlterar ? '' : ' Só leitura nesta conta.');

  return (
    <div className="max-w-3xl space-y-6">
      <PageHeader
        icon={<CalendarOff />}
        title={titulo}
        subtitle={subtitulo}
        // "Voltar" no lugar de sempre (acima do título); o lançamento, no celular, é o FAB.
        backTo={{ label: ROTULO_DA_ORIGEM[voltarPara] ?? 'Voltar', path: voltarPara }}
        actions={
          podeAlterar && (
            <Button className="hidden min-h-10 sm:inline-flex" onClick={() => setLancando(true)}>
              <Plus className="mr-2 h-4 w-4" />
              Lançar feriado ou suspensão
            </Button>
          )
        }
      />

      <Card className="border bg-card">
        <CardContent className="pt-6">
          <ListaDeFeriados podeAlterar={podeAlterar} />
        </CardContent>
      </Card>

      {podeAlterar && (
        <Fab icon={<Plus className="h-6 w-6" />} label="Lançar feriado ou suspensão" onClick={() => setLancando(true)} />
      )}
      {lancando && <LancarAvulsoDialog onClose={() => setLancando(false)} />}
    </div>
  );
}

export default FeriadosPage;
